import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetLoadPlansInputDto, ImportLoadPlansInputDto, LoadPlanCreateDto, LoadPlanDto, LoadPlanExcelDownloadDto, LoadPlanUpdateDto } from '../dtos/load-plan/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class LoadPlanService {
  private restService = inject(RestService);
  apiName = 'Operational';
  

  create = (input: LoadPlanCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, LoadPlanDto>({
      method: 'POST',
      url: '/api/operational/loadPlans',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/operational/loadPlans/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/operational/loadPlans',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, LoadPlanDto>({
      method: 'GET',
      url: `/api/operational/loadPlans/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/operational/loadPlans/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetLoadPlansInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<LoadPlanDto>>({
      method: 'GET',
      url: '/api/operational/loadPlans',
      params: { planTypeId: input.planTypeId, planVersion: input.planVersion, harvestBlockId: input.harvestBlockId, startDate: input.startDate, startDateFrom: input.startDateFrom, startDateTo: input.startDateTo, volume: input.volume, volumeFrom: input.volumeFrom, volumeTo: input.volumeTo, versionId: input.versionId, versionName: input.versionName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: LoadPlanExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/operational/loadPlans/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, planTypeId: input.planTypeId, planVersion: input.planVersion, harvestBlockId: input.harvestBlockId, startDate: input.startDate, startDateFrom: input.startDateFrom, startDateTo: input.startDateTo, volume: input.volume, volumeFrom: input.volumeFrom, volumeTo: input.volumeTo, versionId: input.versionId, versionName: input.versionName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, LoadPlanDto[]>({
      method: 'GET',
      url: '/api/operational/loadPlans/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  import = (input: ImportLoadPlansInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, LoadPlanDto[]>({
      method: 'POST',
      url: '/api/operational/loadPlans/import',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: LoadPlanUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, LoadPlanDto>({
      method: 'PUT',
      url: `/api/operational/loadPlans/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}